import { render, staticRenderFns } from "./betting-records.vue?vue&type=template&id=5e96d838&scoped=true"
import script from "./betting-records.vue?vue&type=script&lang=js"
export * from "./betting-records.vue?vue&type=script&lang=js"
import style0 from "./betting-records.vue?vue&type=style&index=0&id=5e96d838&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e96d838",
  null
  
)

export default component.exports